import { apiPesquisaSatisfacao, apiClientAudio } from '@/plugins/axios'

export default {
  getTodasPesquisasSatisfacao() {
    return apiPesquisaSatisfacao().get('/satisfacao')
  },
  getPesquisaSatisfacaoIndividual(id) {
    return apiPesquisaSatisfacao().get(`/satisfacao/${id}`)
  },
  getPesquisaUse(id) {
    return apiPesquisaSatisfacao().get(`/satisfacao/use/${id}`)
  },
  postPesquisaSatisfacao(data) {
    return apiPesquisaSatisfacao().post('/satisfacao', data)
  },
  putPesquisaSatisfacao(id, data) {
    return apiPesquisaSatisfacao().put(`/satisfacao/${id}`, data)
  },
  deletePesquisaSatisfacao(id) {
    return apiPesquisaSatisfacao().delete(`/satisfacao/${id}`)
  },

  getAudios() {
    return apiClientAudio().get('/audios/lazy')
  },
}
